import { useCallback, useState } from 'react'
import FileSaver from 'file-saver'
// import request from "../../services/request"
import {getDetachedSignatureService, getSignatureService} from "../../services/user"
import { message } from 'antd'

const useDownloadDetachedSignedFiles = () => {
    const [loadingDownLoad, setLoadingDownLoad] = useState<boolean>(false)

    const handleClickDownload = async (requestId: string) => {
        try {
            if (!requestId) {
                return
            }

            setLoadingDownLoad(true)

            // const body = await request.get(`/api/documents/v1/detached-signed-file?request_id=${requestId}&content=body`, {
            //     responseType: 'blob',
            // })
            //
            //
            // const signature = await request.get(`/api/documents/v1/detached-signed-file?request_id=${requestId}&content=signature`, {
            //     responseType: 'blob',
            // })

            const [bodyFile, signatureFile] = await Promise.all([
                getDetachedSignatureService(requestId, true, (error) => {
                    // getSignatureService(requestId, true, (error) => {
                    //     message.error('Ошибка скачивания запроса')
                    //     throw new Error('login error', error.message)
                    // })
                }),
                getDetachedSignatureService(requestId, false, (error) => {
                    // getSignatureService(requestId, false, (error) => {
                    //     message.error('Ошибка скачивания подписи')
                    //     throw new Error('login error', error.message)
                    // })
                }),
            ])

            if (bodyFile?.status === 200 && signatureFile?.status === 200) {
                const bodyBlob = new Blob([bodyFile?.data], {type: 'application/octet-stream'})
                const signatureBlob = new Blob([signatureFile?.data], {type: 'application/octet-stream'})


                FileSaver.saveAs(bodyBlob, decodeURI(bodyFile?.headers.filename))
                FileSaver.saveAs(signatureBlob, decodeURI(signatureFile?.headers.filename))
            } else {
                const [body, signature] = await Promise.all([
                    getSignatureService(requestId, true, (error) => {
                        message.error('Ошибка скачивания запроса')
                        throw new Error('login error', error.message)
                    }),
                    getSignatureService(requestId, false, (error) => {
                        message.error('Ошибка скачивания подписи')
                        throw new Error('login error', error.message)
                    }),
                ])

                const bodyBlob = new Blob([body?.data], { type: 'application/octet-stream' })
                const signatureBlob = new Blob([signature?.data], {
                    type: 'application/octet-stream',
                })

                FileSaver.saveAs(bodyBlob, body?.headers.filename)
                FileSaver.saveAs(signatureBlob, signature?.headers.filename)
            }
        } finally {
            setLoadingDownLoad(false)
        }
    }

    const downloadDetachedSignedFiles = useCallback((requestId: string) => {
        handleClickDownload(requestId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return {
        downloadDetachedSignedFiles,
        loadingDownLoad,
    }
}

export default useDownloadDetachedSignedFiles
